import { render } from "./KPDetailPage.vue?vue&type=template&id=381a0466"
import script from "./KPDetailPage.vue?vue&type=script&lang=js"
export * from "./KPDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__